let handleRef: FileSystemFileHandle | null = null

export function setFileHandle(handle: FileSystemFileHandle | null) {
  handleRef = handle
}

export function getFileHandle(): FileSystemFileHandle | null {
  return handleRef
}

export async function writeToFile(buffer: ArrayBuffer): Promise<boolean> {
  if (!handleRef) return false
  try {
    const writable = await handleRef.createWritable()
    await writable.write(buffer)
    await writable.close()
    return true
  } catch {
    return false
  }
}
